// extracted by mini-css-extract-plugin
export default {"cls1":"UserCard-cls1_nCz","cls2":"UserCard-cls2_TZN UserCard-cls1_nCz","truncateText":"UserCard-truncateText_ih5"};